import { render, staticRenderFns } from "./SubscribeToNewsletterInFooter.vue?vue&type=template&id=f7a46bfc&scoped=true"
import script from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
export * from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
import style0 from "./SubscribeToNewsletterInFooter.vue?vue&type=style&index=0&id=f7a46bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a46bfc",
  null
  
)

export default component.exports